import {
  LazyLoadImage,
  LazyLoadImageProps,
} from "react-lazy-load-image-component";
import placeholder from "assets/img/placeholder.jpg";

function Image(props: LazyLoadImageProps) {
  return (
    <LazyLoadImage
      placeholderSrc={
        props.placeholderSrc != null ? props.placeholderSrc : placeholder
      }
      {...props}
      // onError={({ currentTarget }) => {
      //   currentTarget.onerror = null; // prevents looping
      //   currentTarget.style.display = "none";
      // }}
      // afterLoad={(e) => { console.log(e); }}
    />
  );
}

export default Image;
